<template>
  <div class="neighborViewEdit">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.lab_closeNow')}}</el-button>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="wid100" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_community')" prop="gardenId">
          <el-select 
            v-if="this.isFlag === false || this.isFlag == 'false'"
            class="multiple-select"
            v-model="ruleForm.gardenIds" 
            :placeholder="$t('lang.lab_selectCommunity')"
            multiple
            filterable
            clearable
            @change="change"
            >
            <el-option :key=0 :label="$t('lang.lab_allVillage')" :value=0></el-option>
            <el-option v-for="item in gardens" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select 
            v-else
            class="single-select"
            v-model="ruleForm.gardenId" 
            :placeholder="$t('lang.lab_selectCommunity')"
            >
            <el-option v-for="(item, index)  in garden" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_sort')" prop="orderBy">
                <el-input-number v-model="ruleForm.orderBy" :placeholder="$t('lang.lab_sort')" controls-position="right" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_moduleName')" prop="appModuleName">
          <el-select class="inputWidth" v-model="ruleForm.appModuleName">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:neighborViewEdit
 *@Description:APP布局-编辑/新增
 *@author:李忠亮
 *@Copyright:格众科技
 *@date:2020-08-19
 */
export default {
  data() {
    return {
      saveData: '',
      id: '', // id
      oldsearchUnit: [], // 复选输入框change前的数据
      index: '', // 复选的小区序号
      fileList: [], // 上传
      ruleForm: {
        orderBy: '', // 排序
        appModuleName: '', // 模块名称
        gardenId: '', // 小区ID
        gardenIds: '', // 小区IDs
      },
      rules: {
        orderBy: [{ required: true, message: this.$i18n.t('lang.lab_pleaseContent'), trigger: 'blur' }],
        appModuleName: [{ required: true, message: this.$i18n.t('lang.lab_pleaseContent'), trigger: 'blur' }]
      },
      gardenId: '', // 小区
      gardens: [], // 小区集合
      garden: [], // 所选小区
      isDisabled: true, // 保存的可点击
      isFlag: false, // 编辑:true 新增：false
      options: this.$i18n.t('lang.optionsModule'),
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
    }
  },
  destroyed() {
    window.localStorage.setItem('appplotForm', JSON.stringify(this.ruleForm))
    window.localStorage.setItem('appplotSaveData', JSON.stringify(this.saveData))
  },

  created() {
    // 判断编辑与新增
    this.isFlag = this.$route.query.flag
    if (window.localStorage.getItem('appplotForm')) {
       this.ruleForm = JSON.parse(window.localStorage.getItem('appplotForm'))
        if (this.ruleForm.gardenId) {
          this.ruleForm.gardenId = Number(this.ruleForm.gardenId)
        }
       if (window.localStorage.getItem('appplotSaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('appplotSaveData'))
        }  
      if (this.isFlag == true) {
        this.myGarden()
        this.id = this.$route.query.id
        this.getData()
      } else {
        this.selectGarden()
        this.fileList = []
      }
    } else {
      if (this.isFlag == true) {
        this.myGarden()
        this.id = this.$route.query.id
        this.getData()
      } else {
        this.selectGarden()
        this.fileList = []
      }
    }
  },
  watch: {
    ruleForm: {
      handler(newVal, oldVal) {
        // ruleForm数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    // 上传文件的断网
    uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
            const loading = this.$loading()
            setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
            }, 500)
        }
    },
    // 编辑页图片直接替换
    checkEdit() {
      if (this.id != '') {
        this.fileList = []
      }
    },
    // 小区下拉
    myGarden() {
      let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.garden = myGardens
    },
    // 小区下拉
    selectGarden() {
      this.$get(`/gardens`).then(
        res => {
          if (res && res.errCode === 0) {
            this.gardens = res.list
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // id查询详情
    getData() {
      let loading = this.$loading()
      this.$get(`/appplot/` + this.id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            console.log(res)
            this.ruleForm = res
            // gardenId字符串转数字值
            this.ruleForm.gardenId = Number(this.ruleForm.gardenId)
            // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
            this.saveData = JSON.stringify(this.ruleForm)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 保存
    save(formName) {
      if (this.isFlag === false) {
        // 验证所属小区是否为空
        if (this.ruleForm.gardenIds.length === 0) {
          this.$message.error(this.$i18n.t('lang.lab_selectOneVillage'))
          return
        }
        // 删除数组中的全选"0"
        if (this.ruleForm.gardenIds.includes(0)) {
          this.ruleForm.gardenIds.splice(0, 1)
        }
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          if (this.isFlag) {
            let params = {
              gardenId: this.ruleForm.gardenId,
              orderBy: this.ruleForm.orderBy,
              appModule: this.ruleForm.appModuleName,
            }
            this.$patch(`/appplot/${this.id}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_modify_success'))
                  var index = this.$keepAlive.indexOf('/manage/main.appplotList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({ name: 'appplotList' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            console.log(this.ruleForm.gardenIds.toString())
            let params = { 
              'garden[]': this.ruleForm.gardenIds.toString(),
              'orderBy': this.ruleForm.orderBy,
              'appModule': this.ruleForm.appModuleName,
            }
            this.$post(`/appplot`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  var index = this.$keepAlive.indexOf('/manage/main.appplotList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({ name: 'appplotList' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        } else {
          return false
        }
      })
    },
    // 返回
    back() {
      this.$router.push({ name: 'appplotList' })
    },
    // 清空
    resetForm(formName) {
      this.$refs.ruleForm.clearValidate()
      this.ruleForm.orderBy = '' // 排序
      this.ruleForm.appModule = '' // 模块
      if (this.isFlag === false) {
        this.ruleForm.gardenIds = ''
      }
    },
    // 图片上传数量超过提醒
    outlimit() {
      this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
    },
    // 图片上传
    handleSuccess(response, file, fileList) {
      console.log('Upload Success!', file, fileList)
      this.ruleForm.image = file.response.data[0]
    },
    // 上传
    submitUpload() {
      this.$refs.upload.submit()
    },
    // 多选项
    change(val) {      
      const allValues = []
      // 将全选"0"加入allValues
      allValues.push(0)
      for (const item of this.gardens) {
        allValues.push(item.id)
      }
      // 用来储存上一次选择的值，可进行对比
      const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
      // 若选择全部
      if (val.includes(0)) {
        this.ruleForm.gardenIds = allValues
      }
      // 取消全部选中， 上次有， 当前没有， 表示取消全选
      if (oldVal.includes(0) && !val.includes(0)) {
        this.ruleForm.gardenIds = []
      }
      // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
      if (oldVal.includes(0) && val.includes(0)) {
        const index = val.indexOf(0)
        val.splice(index, 1)
        this.ruleForm.gardenIds = val
      }
      // 全选未选，但是其他选项都全部选上了，则全选选上
      if (!oldVal.includes(0) && !val.includes(0)) {
        if (val.length === allValues.length - 1) {
          this.ruleForm.gardenIds = [0].concat(val)
        }
      }
      // 储存当前选择的最后结果 作为下次的老数据
      this.oldsearchUnit[0] = this.ruleForm.gardenIds
    },

  }
}
</script>

<style lang="scss">
.neighborViewEdit {
  .single-select {
    width: 30%;
  }
  .multiple-select {
    width: 50%;
  }
  .input-width{
    width: 60%;
  }
  .img {
    width: 200px;
    height: 150px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }
}
</style>